<template>
  <div class="s-strip s-leasing-offers-compare">
    <div class="page-container">
      <SlickCarousel
        ref="slick"
        class="s-leasing-offers-compare__slick"
        :options="slickOptions">
        <div v-for="item in records" :key="item.id" class="item">
          <div class="mb-80">
            <VehicleCompareCard
              :item="item"
              @change-vat="onToggleVatIncluded" />
            <button
              type="button"
              class="btn btn-link btn-remove"
              :disabled="records.length < 3"
              @click="removeVehicle(item.id)">
              {{ dictionary.removeVehicleButtonText }}
            </button>
          </div>

          <div class="b-tech-characteristics-table stand-alone mb-40">
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.paymentInAdvanceLabel }}:</span>
                <span v-if="!item.vatIncluded">
                  {{ priceHasValue(item.paymentInAdvance) }}
                </span>
                <span v-else class="highlight">
                  {{ priceHasValue(item.paymentInAdvanceIncldVat) }}
                </span>
              </div>
            </div>
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.retailPriceLabel }}:</span>
                <span>{{ item.retailPrice }}</span>
              </div>
            </div>
            <div class="row gx-5">
              <div class="col">
                <span>{{ dictionary.retailPriceBeforeTaxesLabel }}:</span>
                <span>
                  {{ item.retailPriceBeforeTaxes }}
                </span>
              </div>
            </div>
          </div>

          <AccordionLarge
            :title="dictionary.techTitle"
            :is-active-prop="true"
            class="theme-grey theme-icon-cirle mb-40">
            <div class="b-tech-characteristics-table">
              <div class="row gx-5">
                <div class="col">
                  <span>{{ dictionary.transmissionLabel }}:</span>
                  <span>{{ item.transmissionType }}</span>
                </div>
              </div>
              <div class="row gx-5">
                <div class="col">
                  <span>{{ dictionary.fuelLabel }}:</span>
                  <span>{{ item.fuel }}</span>
                </div>
              </div>
              <div class="row gx-5">
                <div class="col">
                  <span>{{ dictionary.consumptionLabel }}:</span>
                  <span>
                    {{ item.consumption }}
                  </span>
                </div>
              </div>
              <div class="row gx-5">
                <div class="col">
                  <span>{{ dictionary.emissionsLabel }}:</span>
                  <span>{{ item.emissions }}</span>
                </div>
              </div>
            </div>
          </AccordionLarge>

          <AccordionLarge
            :title="dictionary.equipmentTitle"
            :is-active-prop="true"
            class="theme-grey theme-icon-cirle mb-80">
            <div style="padding: 20px">
              <div class="row gx-5">
                <!-- col -->
                <div v-auto-animate class="col">
                  <ul class="is-checked">
                    <li v-for="(spec, index) in getSpecs(item)" :key="index">
                      {{ spec }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </AccordionLarge>
        </div>
      </SlickCarousel>
    </div>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import constants from './../../lib/constants'
import VehicleCompareCard from './../components/leasingOffers/VehicleCompareCard.vue'
import AccordionLarge from './../components/BookingAccordion.vue'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: {
    AccordionLarge,
    VehicleCompareCard,
    SlickCarousel,
  },
  data() {
    return {
      records: [],
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    }
  },
  mounted() {
    const { records } = lib.getData('leasingCompareData')
    this.records = records
    this.records.forEach((x) => (x.vatIncluded = false))
  },
  methods: {
    priceHasValue(price) {
      if (price === null || price === undefined) return '-'
      if (price.length <= 1) return '-'

      const priceWithoutEuroSign = price.slice(1)

      return priceWithoutEuroSign > 0 ? price : '-'
    },
    removeVehicle(id) {
      this.records = this.records.filter((x) => x.id !== id)
    },
    getSpecs(value) {
      return value.characteristics
    },

    getTransmissionLabel(value) {
      let res
      const { manual, auto } = constants.leaseitnow.filters.transmissionsOptions

      switch (value) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },

    onToggleVatIncluded(value, id) {
      this.records.find((x) => x.id === id).vatIncluded = value
    },
  },
}
</script>
